export default {
  SET_ELOMARK_USERS(state, elomark_users) {
    state.elomark_users = elomark_users
  },
  REMOVE_ACCOUNT(state, itemId) {
      const accountIndex = state.elomark_users.datas.findIndex((u) => u.id == itemId)
      state.elomark_users.datas.splice(accountIndex, 1)
  },
  SELECTED_ACCOUNT(state,data){
    state.elomark_users.datas = []
    state.elomark_users.total = 1;
    state.elomark_users.per_page = 1;
    state.elomark_users.datas.push(data)
  },
  SET_PHONE_TYPES(state,phone_types){
    state.phone_types = phone_types
  },
  SET_ELOMARK_ROLE_TYPES(state,elomark_role_types){
    state.elomark_role_types = elomark_role_types
  },
  SET_ELOMARK_USER_STATUS(state,elomark_user_status){
    state.elomark_user_status = elomark_user_status
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  SET_VERTICALS(state,data){
    state.verticals = data
  },
  SET_COUNTRIES(state,data){
    state.countries = data
  },
  SET_ELOMARK_USER(state,data){
    state.elomark_user = data
  },
  EDIT_ITEM(state,data){
    state.elomark_user = data
  },
  ADD_ITEM(state,data){
    state.elomark_user = data
  },
  SET_ALL_TIME_ZONES(state,data){
    state.all_time_zone = data
  },
  GET_ALL_LANGUAGES(state,data){
    state.all_languages = data
  },
  SET_CAMPAIGN_ASSOCIATED_CLIENT_CONTACT(state, campaign_associated_client_contact) {
    state.campaign_associated_client_contact = campaign_associated_client_contact
  },
}
